module.exports = __webpack_public_path__ + "static/media/VisitContaint.53eed4c6.svg";